import { createStructureDslParser } from './createStructureDslParser';
import { emptyStructure } from './emptyStructure';
import { printCrudStructureStmts } from './printStructure';
import { statementStructureHandlerMap } from './stmtsList';
import { StructureDslBuilder } from './StructureDslBuilder';
export const buildStructureFromDsl = (input, schema, schemaExtensions) => {
    const parser = createStructureDslParser();
    const parserResult = parser.parse(input);
    const statements = parserResult.statements;
    const modelBuild = buildStructureFromStatements(statements, schema, schemaExtensions);
    modelBuild.errors.push(...parserResult.errors);
    return modelBuild;
};
export const buildStructureFromStatements = (statements, schema, schemaExtensions) => {
    const builder = new StructureDslBuilder(emptyStructure, schema, schemaExtensions, statementStructureHandlerMap);
    const applyResult = builder.applyStatements(statements);
    return {
        errors: [...applyResult.errors],
        structure: applyResult.application,
        statements: statements,
    };
};
export const buildCrudStructure = (schema, schemaExtensions, applicationType) => {
    const dsl = printCrudStructureStmts(schema, schemaExtensions, applicationType);
    const parser = createStructureDslParser();
    const parserResult = parser.parse(dsl);
    const statements = parserResult.statements;
    return {
        dsl,
        statements,
    };
};
//# sourceMappingURL=buildStructureFromSource.js.map